import type { HttpClient } from '@shared/http/http-client';
import type {
  IResourceRepository,
  ResourceListQuery,
} from '@domain/data-contracts/resource-repository.interface';
import type { Resource } from '@domain/models/resource.interface';
import type { PagedResult } from '@domain/models/paging.interface';
import {
  mapResourceDto,
  mapPaged,
  type ResourceDto,
  type PagedDto,
} from './mapping.helper';

const BASE = '/api/resources';

export class ResourceRepository implements IResourceRepository {
  public constructor(private readonly http: HttpClient) {}

  public async list(query: ResourceListQuery): Promise<PagedResult<Resource>> {
    const response = await this.http.get<PagedDto<ResourceDto>>(BASE, {
      params: pruneParams(query),
    });
    return mapPaged(response.data, mapResourceDto);
  }
}

function pruneParams(query: ResourceListQuery): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (query.search && query.search.trim().length > 0) { out.search = query.search.trim(); }
  if (query.type) { out.type = query.type; }
  if (typeof query.page === 'number') { out.page = query.page; }
  if (typeof query.pageSize === 'number') { out.pageSize = query.pageSize; }
  return out;
}
